import type { HelpFile } from '../../types/help'
import { AdminNotificationLogTestIds } from '../../../testids/AdminNotificationLogTestIds'

export const adminNotificationLogHelp: HelpFile = {
  docPage: '/docs/my-iam/notifications',
  texts: {
    [AdminNotificationLogTestIds.adminNotificationLog]:
      'Systemweites Protokoll aller versendeten Benachrichtigungen — Empfänger, Ereignis, Zustellstatus und etwaige Fehler.',
    [AdminNotificationLogTestIds.colDate]: null,
    [AdminNotificationLogTestIds.colSentAt]:
      'Tatsächlicher Zustellzeitpunkt — kann vom Erstellungszeitpunkt abweichen, wenn die Benachrichtigung in der Warteschlange war.',
    [AdminNotificationLogTestIds.colEventType]:
      'IAM-Ereignis, das diese Benachrichtigung ausgelöst hat — z. B. Zugriff gewährt oder Antrag genehmigt.',
    [AdminNotificationLogTestIds.colTitle]: null,
    [AdminNotificationLogTestIds.colRecipient]: null,
    [AdminNotificationLogTestIds.colDeliveryStatus]:
      'Zustellergebnis — versendet, ausstehend oder fehlgeschlagen.',
    [AdminNotificationLogTestIds.colError]:
      'Fehlerdetail, das bei gescheiterter Zustellung erfasst wurde.',
    [AdminNotificationLogTestIds.notificationStatusSent]:
      'Benachrichtigung wurde erfolgreich zugestellt.',
    [AdminNotificationLogTestIds.notificationStatusPending]:
      'Benachrichtigung wartet in der Warteschlange auf die Zustellung.',
    [AdminNotificationLogTestIds.notificationStatusFailed]:
      'Zustellung der Benachrichtigung ist fehlgeschlagen — Details siehe Fehlerspalte.',
  },
}
